import request from '@/utils/httpClient'
import { StoragePageParams, StorageHistoryPageParams } from '@/types/domain/storage'

// 分页查询库存 (类型化领域查询)
export function getStoragePage(params?: StoragePageParams) {
  return request({
    url: 'storage/page',
    method: 'get',
    params
  })
}

// 库位库存列表
export function getStorageByLocation(locationId: number, params?: Record<string, any>) {
  return request({
    url: `storage/actions/location/${locationId}`,
    method: 'get',
    params
  })
}

// 出入库历史
export function getStorageHistories(locationId: number, materialId: number, params?: StorageHistoryPageParams) {
  return request({
    url: `storage/actions/histories/${locationId}/${materialId}`,
    method: 'get',
    params
  })
}
